import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import "../clap/ClapNoticeInformation.scss";
import "../../../layout/styles/inline-cgos.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import { ProgressSpinner } from 'primereact/progressspinner';

import { useDispatch, useSelector } from "react-redux";
import { getUsagerInfo } from "../../../store/actions/usager";
import {setFiche, setFullActionSociale} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";

import { AgentService } from "../../../service/AgentService";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../clap/DemandeClap.scss";

import {ChangementRibNoticeInformation} from "./ChangementRibNoticeInformation";
import {FormulaireChangementRib} from "./FormulaireChangementRib";


export const DemandeChangementRib = () => {
  const createMode = "create";
  const editMode = "edit";

  const { mode } = useParams();

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);

  const [editFormData, setEditFormData] = useState(null);
  const [currentActionSociale, setCurrentActionSociale] = useState({});

  const [disabledForm, disableForm] = useState(true);
  const [hiddenNoticeButton, hideNoticeButton] = useState(editMode === mode ? true : false);
  const [activeIndex, setActiveIndex] = useState([0]);

  const [displayBasic, setDisplayBasic] = useState(false);
  const [demandeEncours, setDemandeEncours] = useState(false);

  const [hideButton, setHideButton] = useState(false);


  const agentService = new AgentService();
  const chequeCultureService = new ChequeCultureService();

  const linkService = new LinkProviderService();

  const dispatch = useDispatch();
  const history = useHistory();


  useEffect(() => {

    if (createMode === mode) {
          fetchDataForCreation();
      } else if (editMode === mode) {
      fetchDataForEdition();
    }
    initActiveIndex();
  }, []);

  
  useEffect(() => {
    if(createMode === mode) disabledForm ? setActiveIndex([0]) : setActiveIndex([1]);
    if(editMode === mode) setActiveIndex([1]);

  }, [disabledForm]);
  

  const fetchDataForEdition = async() => {
    dispatch(getUsagerInfo());

  };

   const fetchDataForCreation = async() => {
       dispatch(getUsagerInfo()).then((res) => {
          isDemandeEnCours(res.numCgos,"CHGT1",localStorage.getItem('exerciceEnCours'));
       }
       )

    };

     const isDemandeEnCours = async (numCgos,codeCas,exercice) => {
       chequeCultureService
         .isDemandeEnCours(numCgos,codeCas)
         .then((res) => {
           if(!res.data){
            setDemandeEncours(true);
           }
         })
         .catch((error) => {
           console.log(error);
         });
     };




  const initActiveIndex = () => {
    if(createMode === mode) setActiveIndex([0]);
    if(editMode === mode) setActiveIndex([1]);
  };

  const handleConfirm = (e) => {
    setActiveIndex([1]);
    setHideButton(true);
  };

  return (
    <div className="grid cld-width">
      <ChequeCultureLegacy />

  <div className="col-12 mx-auto">
          <div
            className="no_shadow_no_border card "
            style={{ display: !displayBasic ? "block" : "none"}}
          >
            <nav aria-label="breadcrumb" class="pt-3">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a
                    href={linkService.getRetourEaAccueilAgent()}
                    target="_self"
                  >
                    Espace Agent
                  </a>
                </li>
                <li class="breadcrumb-item">
                  <a
                    href={linkService.getRetourEaPreferenceBancaires()}
                    target="_self"
                  >
                    Références bancaires
                  </a>
                </li>

                <li aria-current="page" class="breadcrumb-item active">
                  Modifier
                </li>
              </ol>
            </nav>

            <p></p>
            
            {currentActionSociale && (
              <div>
                <h1 style={{ color: "#676767", fontWeight: 300 }}>
                  Références bancaires
                </h1>
              </div>
            )}
            
            <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                
                <AccordionTab header={<h2> A savoir avant de commencer</h2>}>
                <div>
                  { demandeEncours && (mode == createMode) && <div className="alert alert-danger" style={{textAlign:"center"  }}>
                                <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif",}}>Vous ne pouvez pas utiliser ce formulaire pour le moment
                                 <b> car vous avez déjà une demande de changement de références bancaires en cours de traitement.</b></span>
                          </div>}
                  <ChangementRibNoticeInformation mode={mode} hiddenNoticeButton={hiddenNoticeButton} onConfirm={(e) => handleConfirm(e)} />
                      <div className="next-button-wrapper">
                        <button type="button" className={ (demandeEncours || hideButton )? "disabled": "btn_submit_modal"} style={demandeEncours ? {pointerEvents: "none"}: {}} onClick={(e) => handleConfirm(e)} > ENVOYER UNE DEMANDE EN LIGNE </button>
                      </div>
                 </div>
                </AccordionTab>

                <AccordionTab disabled={demandeEncours || !hideButton} header={<h2> { createMode === mode ? "Envoyer une demande" : "Compléter votre demande" }</h2>}>
                  <FormulaireChangementRib mode={mode} oldForm={editFormData}  />
                </AccordionTab>
                
              </Accordion>
              
          </div>
        </div>
    </div>
    
  );
  
  
};


